<section>
  <router-outlet class="tab-content"></router-outlet>
</section>
